var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedOutlineGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 0.333374C3.32004 0.333374 0.333374 3.32004 0.333374 7.00004C0.333374 10.68 3.32004 13.6667 7.00004 13.6667C10.68 13.6667 13.6667 10.68 13.6667 7.00004C13.6667 3.32004 10.68 0.333374 7.00004 0.333374ZM7.00004 12.3334C4.06004 12.3334 1.66671 9.94004 1.66671 7.00004C1.66671 4.06004 4.06004 1.66671 7.00004 1.66671C9.94004 1.66671 12.3334 4.06004 12.3334 7.00004C12.3334 9.94004 9.94004 12.3334 7.00004 12.3334ZM9.58671 4.52671L5.66671 8.44671L4.41337 7.19337C4.15337 6.93337 3.73337 6.93337 3.47337 7.19337C3.21337 7.45337 3.21337 7.87337 3.47337 8.13337L5.20004 9.86004C5.46004 10.12 5.88004 10.12 6.14004 9.86004L10.5334 5.46671C10.7934 5.20671 10.7934 4.78671 10.5334 4.52671C10.2734 4.26671 9.84671 4.26671 9.58671 4.52671Z",
    fill: "#ABB6AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedOutlineGrey);
export default __webpack_public_path__ + "static/media/checked_outline_grey.3a5c1f63a887230590fa2c9bb00ac723.svg";
export { ForwardRef as ReactComponent };